// react_frontend/src/Components/Modules/Accounting/VATReport.js
import React, { useState, useEffect } from 'react';
import { AxiosAuthInstance } from '../../../AxiosInterceptors';
import Breadcrumb from '../../Partials/Breadcrumb';
import {
    Box, Typography, Paper, TextField, Button, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, Grid, Card, CardContent
} from '@mui/material';
import { FaSearch, FaFileInvoice } from 'react-icons/fa';

export default function VATReport() {
    const [salesVat, setSalesVat] = useState([]);
    const [purchaseVat, setPurchaseVat] = useState([]);
    const [totals, setTotals] = useState({ sales: 0, purchase: 0, net: 0 });
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const fetchVAT = async () => {
        try {
            const res = await AxiosAuthInstance.get('accounting/reports/vat-report', {
                params: { from_date: fromDate, to_date: toDate }
            });
            setSalesVat(res.data.sales_vat || []);
            setPurchaseVat(res.data.purchase_vat || []);
            setTotals({
                sales: res.data.total_sales_vat || 0,
                purchase: res.data.total_purchase_vat || 0,
                net: res.data.net_vat_payable || 0,
            });
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => { fetchVAT(); }, []);

    return (
        <Box sx={{ p: 3, bgcolor: '#f5f7fa', minHeight: '100vh' }}>
            <Breadcrumb title="VAT Report" />
            <Paper sx={{ p: 3, mb: 3 }}>
                <Typography variant="h5" fontWeight={700} mb={2}>VAT / Mushak Report</Typography>
                <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                    <TextField label="From Date" type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} size="small" InputLabelProps={{ shrink: true }} />
                    <TextField label="To Date" type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} size="small" InputLabelProps={{ shrink: true }} />
                    <Button variant="contained" onClick={fetchVAT} startIcon={<FaSearch />}>Generate</Button>
                </Box>

                <Grid container spacing={3} sx={{ mb: 3 }}>
                    <Grid item xs={12} md={4}>
                        <Card sx={{ bgcolor: '#e3f2fd' }}>
                            <CardContent>
                                <Typography variant="caption">Sales VAT (Mushak-6.3)</Typography>
                                <Typography variant="h5" fontWeight={700} color="primary">৳{Number(totals.sales).toLocaleString()}</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Card sx={{ bgcolor: '#fff3e0' }}>
                            <CardContent>
                                <Typography variant="caption">Purchase VAT (Mushak-9.11)</Typography>
                                <Typography variant="h5" fontWeight={700} color="warning.main">৳{Number(totals.purchase).toLocaleString()}</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Card sx={{ bgcolor: totals.net >= 0 ? '#e8f5e9' : '#ffebee' }}>
                            <CardContent>
                                <Typography variant="caption">Net VAT Payable</Typography>
                                <Typography variant="h5" fontWeight={700} color={totals.net >= 0 ? 'success.main' : 'error.main'}>৳{Number(Math.abs(totals.net)).toLocaleString()}</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>

                <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}><FaFileInvoice style={{ marginRight: 8 }} />Sales VAT Details</Typography>
                <TableContainer sx={{ mb: 3 }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow sx={{ bgcolor: '#e3f2fd' }}>
                                <TableCell>Date</TableCell>
                                <TableCell align="right">Invoices</TableCell>
                                <TableCell align="right">Total Sales</TableCell>
                                <TableCell align="right">VAT Amount</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {salesVat.map((row, idx) => (
                                <TableRow key={idx}>
                                    <TableCell>{row.date}</TableCell>
                                    <TableCell align="right">{row.invoice_count}</TableCell>
                                    <TableCell align="right">৳{Number(row.total_sales).toLocaleString()}</TableCell>
                                    <TableCell align="right">৳{Number(row.total_vat).toLocaleString()}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}><FaFileInvoice style={{ marginRight: 8 }} />Purchase VAT Details</Typography>
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow sx={{ bgcolor: '#fff3e0' }}>
                                <TableCell>Date</TableCell>
                                <TableCell align="right">Bills</TableCell>
                                <TableCell align="right">Total Purchase</TableCell>
                                <TableCell align="right">VAT Amount</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {purchaseVat.map((row, idx) => (
                                <TableRow key={idx}>
                                    <TableCell>{row.date}</TableCell>
                                    <TableCell align="right">{row.bill_count}</TableCell>
                                    <TableCell align="right">৳{Number(row.total_purchase).toLocaleString()}</TableCell>
                                    <TableCell align="right">৳{Number(row.total_vat).toLocaleString()}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Box>
    );
}